<template>
  <v-card
    height="100%"
    class="d-flex flex-column justify-start"
  >
    <v-card
      :to="{ name: 'flipItem', params: { id: asset.id }}"
      tile
    >
      <v-img
        aspect-ratio="1"
        :src="asset.mainImage"
        :alt="asset.title"
        class="flex-grow-0"
      ></v-img>
    </v-card>

    <v-card-title class="text-center justify-center">{{ asset.title }}</v-card-title>

    <v-card-text class="text-center">
<!-- <div> {{ asset.fundingState }}</div> -->
      <div v-if="asset.fundingState !== 'Purchased' && asset.salesModel == 'flip'" style="padding-bottom: 10px;">
        Projected ROI - {{ asset.projectedRoi }}%
      </div>
      <div v-if="asset.auctionDate > Date.now() && asset.fundingState !== 'PendingPurchase' && asset.auctionDate !== null">
        Auction Date - {{ asset.auctionDate | timestampToDate }}
      </div>
      <div v-else-if="asset.fundingState !== 'Purchased' && asset.auctionDate !== null && asset.fundingState !== 'PendingPurchase'">
        Funding is Closed - Auction LIVE
      </div>
      <div v-else-if="asset.actualRoi">
        Realized Shared ROI <br />{{ asset.actualRoi }}% ROI
      </div>
      <div v-else-if="asset.fundingState === 'PendingPurchase'">
        Pending Sale
      </div>
      <!-- <div v-if="asset.buyItNowPrice && asset.fundingState != 'InAuction' && asset.fundingState != 'Purchased'">
        Buy Car Now: {{ asset.buyItNowPrice | numberToMoney }}
      </div> -->
      <div style="padding-top: 10px;"
        v-if="asset.fundingState !== 'SoldOut' && asset.fundingState !== 'Suspended' && asset.fundingState !== 'PendingPurchase' && (asset.auctionDate > Date.now() || asset.auctionDate == null)"
      >
        <!-- {{ asset.numberOfShares }} Shares @ {{ asset.sharePrice | numberToMoney }}/share -->
        Funding Now<br />{{ asset.totalShares }} Shares @ {{ asset.sharePrice | numberToMoney }}/share
      </div>
      <div style="padding-top: 10px;"
        v-if="asset.fundingState === 'Suspended'"
      >
        Coming Soon
      </div>
      <div v-if="asset.fundingState === 'SoldOut'">Funding Closed</div>
      <!-- <div v-else-if="asset.auctionDate > Date.now()">{{ asset.buyItNowPrice | numberToMoney }}</div> -->
    </v-card-text>

    <v-card-actions
      v-if="asset.fundingState !== 'Purchased'"
      class="mt-auto flex-wrap justify-center"
    >
      <!-- <v-btn
        v-if="authenticated && asset.buyItNowPrice && asset.fundingState != 'InAuction'"
        x-small
        class="mb-3 mr-2"
        @click.stop="buyItForm(asset.id)"
      >
        Buy Car Now
      </v-btn>
      <v-btn
        v-else-if="asset.buyItNowPrice && asset.fundingState != 'InAuction'"
        @click="bounceBack(asset.id)"
        x-small
        class="mb-3 mr-2"
      >
        Buy Car Now
      </v-btn>
      <v-dialog
        v-model="buyItNow"
        :fullscreen="$vuetify.breakpoint.mobile"
        :transition="$vuetify.breakpoint.mobile ? 'dialog-bottom-transition' : '' "
        max-width="500px"
      >
        <BuyItNowForm
          v-on:dialog-close="buyItNow = false"
        ></BuyItNowForm>
      </v-dialog> -->

      <v-btn
        v-if="asset.fundingState === 'InAuction'"
        x-small
        class="mb-3"
        :href="asset.auctionLink"
        target="_blank"
      >
        Go to Auction
      </v-btn>

      <v-btn
        v-if="authenticated && asset.fundingState !== 'SoldOut' && asset.fundingState !== 'InAuction' && asset.fundingState !== 'Suspended' && asset.fundingState !== 'PendingPurchase'"
        x-small
        class="mb-3 mr-2"
        @click.stop="sharesForm(asset.id)"
      >
        Buy Shares
      </v-btn>
      <v-btn
        v-else-if="asset.fundingState !== 'SoldOut' && asset.fundingState !== 'InAuction' && asset.fundingState !== 'Suspended' && asset.fundingState !== 'PendingPurchase'"
        @click="bounceBack(asset.id)"
        x-small
        class="mb-3 mr-2"
      >
        Buy Shares
      </v-btn>
      <v-dialog
        v-model="buyShares"
        :fullscreen="$vuetify.breakpoint.mobile"
        :transition="$vuetify.breakpoint.mobile ? 'dialog-bottom-transition' : '' "
        max-width="500px"
      >
        <PurchaseShareForm
            ref="purchaseForm"
          v-on:dialog-close="buyShares = false"
        ></PurchaseShareForm>
      </v-dialog>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import PurchaseShareForm from './PurchaseShareForm.vue'
  //import BuyItNowForm from './BuyItNowForm.vue'

  export default {
    name: 'CarCard',

    components: {
      PurchaseShareForm,
      //BuyItNowForm
    },

    props: {
      asset: Object
    },

    computed: {
      ...mapGetters([
        'authenticated',
        'loginRedirect'
      ])
    },

    watch: {
      buyShares(visible) {
        if (visible) {
          if (this.$refs.purchaseForm) {
            this.$refs.purchaseForm.dialogOpen()
          }
        }
      }
    },

    methods: {
      ...mapActions(['getFlipAssetById']),

      // Since we may not have the right asset in state,
      // make sure you load it.
      loadAsset: function (id) {
        return this.getFlipAssetById(id)
      },

      sharesForm: function (id) {
        this.loadAsset(id).then(() => {
          // Open the dialogue.
          this.buyShares = true
        })
      },

      buyItForm: function (id) {
        this.loadAsset(id).then(() => {
          // Open the dialogue.
          this.buyItNow = true
        })
      },

      bounceBack: function(assetId) {
        this.$cookies.set('assetBounce', assetId, '', '/')
        window.location.href = this.loginRedirect
      }
    },

    data: () => ({
      // Dialog handling.
      buyShares: false,
      buyItNow: false
    })
  }
</script>
